import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivityType } from '../_models/activityType';
import { User } from '../_models/user';
import { UserActivity } from './../_models/userActivity';
import { DataUtilService } from './data-util.service';

import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthHeader } from '../_models/headers';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ActivityService {
  public registeredUser = new User()
  public userRegResponse = { rs: { status: 0 } }

  public registrationData: BehaviorSubject<User> = new BehaviorSubject<User>(new User());
  public responseObservable = this.registrationData.asObservable
  headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
  aHeader = undefined
  options = { headers: this.headers }
  constructor(
    private http: HttpClient,
    private dataUtilService: DataUtilService,
    private tss:AuthService
  ) {this.aHeader =new AuthHeader(tss) }
  getAllActivityTypes() {
    return this.http.get<ActivityType[]>(`${environment.apiUrl}/activityType/apiindex`,this.aHeader.bearerJsonHeaders).pipe(map(
      val => {
        if (this.dataUtilService.isGoodResponse(val)) {
          return this.dataUtilService.myData(val)
        }
      }
    ))
  }
  getUserLastActivities(){
    return this.http.get<UserActivity[]>(`${environment.apiUrl}/userEngagement/apiindex`,this.aHeader.bearerJsonHeaders).pipe(map(
      val => {
        if (this.dataUtilService.isGoodResponse(val)) {
          return this.dataUtilService.myData(val)
        }
      }
    ))
  }
  getAllUserActivities() {
    return this.http.get<UserActivity[]>(`${environment.apiUrl}/userActivity/apiindex`,this.aHeader.bearerJsonHeaders).pipe(map(
      val => {
        if (this.dataUtilService.isGoodResponse(val)) {
          return this.dataUtilService.myData(val)
        }
      }
    ))
  }
  getActivityTypeById(id: number) {
    return this.http.get<ActivityType>(`${environment.apiUrl}/activityType/apishow/${id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      val => {
        if (this.dataUtilService.isGoodResponse(val)) {
          return this.dataUtilService.myData(val)
        }
      }
    ))
  }
  newActivity(activityType: ActivityType) {
    return this.http.post(`${environment.apiUrl}/activityType/apinew`, activityType.formData(), this.options)
      .pipe(map(sInfo => {
        if(this.dataUtilService.isGoodResponse(sInfo)){
         return this.dataUtilService.myData(sInfo)

        }
      }));
  }

  update(activityType: ActivityType) {
    return this.http.post(`${environment.apiUrl}/user/apiupdate`, activityType.formData(), this.options)
      .pipe(map(sInfo => {
        if(this.dataUtilService.isGoodResponse(sInfo)){
          return  this.dataUtilService.myData(sInfo)

        }
      }));
  }

}
